import React, { useState, useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react'
import ReadAxios from '../axiosComponent/read';

const MyRoute = ({
    value,
    handleChange
}) => {
    const [content, setcontent] = useState([])
    const [loading, setloading] = useState(false)
    useEffect(() => {
        ReadAxios({ url: 'routeMaster' })
            .then((result) => {
                setcontent(result.data.resultSet)
                setloading(false)
            })
    }, [])

    const handleSearch = (e, data) => {
        setloading(true)
        let searchTerm = data.searchQuery
        ReadAxios({ url: 'routeMaster', readItems: { searchTerm: searchTerm } })
            .then((result) => {
                setcontent(result.data.resultSet)
                setloading(false)
            })
    }
    let options = []
    if (content?.length > 0) {
        content.map((object, index) => {
            let temp = {}
            temp.key = object.routeCode
            temp.text = `${object.routeName} (${object.routeCode})`
            temp.value = object.routeMasterId
            return options[index] = temp
        })
    }

    return (
        <Dropdown
            selection
            search
            loading={loading ? true : false}
            style={{ width: '100%', display: 'inline-table' }}
            onChange={handleChange}
            options={options}
            clearable
            onSearchChange={handleSearch}
            value={value}
        />
    )
}

export default MyRoute